import styled from 'styled-components';
import { Paper, Typography } from '@material-ui/core';

interface ContainerProps {
  marginLeft?: boolean;
}

export const Container = styled(Paper)<ContainerProps>`
  margin-left: ${props => (props.marginLeft ? '30px' : '0px')};
  margin-bottom: 20px;
  border-radius: 0px;
`;

export const Content = styled.div`
  padding: 16px;
  color: ${props => (props.color ? props.color : '#000000de')};
`;

export const Header = styled.div`
  background-color: #0880bc1a;
  height: 47px;
  padding: 10px;
  display: flex;
  align-items: center;
`;

export const RightButton = styled.div`
  margin-left: auto;
`;

export const IconWrapper = styled.div`
  margin-right: 20px;
`;

export const Title = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  color: #0075c9;
  text-transform: uppercase;
`;
